import * as React from "react";

import { Button } from "semantic-ui-react";

import { ActionableTask } from "../models";

import { Link } from "redux-little-router";

export const EmployeeReviewMHPTreatmentReport = (task: ActionableTask) => {
    if (task.completed) {
        return (
            <Link href={`/cases/${task.ohCaseId}/${task.id}/mhp-treatment-report`}>
                <Button secondary content="View report" />
            </Link>);
    }

    return (
        <Link href={`/actions/${task.ohCaseId}/${task.id}/review-mhp-treatment-report`}>
            <Button content="Review" />
        </Link>);
};
